import AssetsModel from './assets';

export default {
    create(params) {
        const flight = {
            availableAssets: null,
            assetData: AssetsModel.create(),
            players: [],
            claims: [{
                reservationId: null,
                selectedDayPart: 'morning',
                times: null,
                startHole: 1,
                numberOfHoles: '18',
                startTime: null,
            }],
            updating: false,
            opened: false,
        };

        if (!params) {
            return flight;
        }

        // Merge objects using ES6 array seperator.
        // https://davidwalsh.name/merge-objects.
        return { ...flight, ...params };
    },
};
